import { api } from './api'

export const whatsappService = {
  /**
   * Lista conversaciones de WhatsApp de la empresa activa (paginado).
   * @param {{ page?: number, limit?: number }} params
   */
  async getConversations({ page = 1, limit = 20 } = {}) {
    return api.get(`/whatsapp/conversations?page=${page}&limit=${limit}`, true)
  },

  /**
   * Mensajes de una conversación específica (paginado, orden desc).
   * @param {number|string} conversationId
   * @param {{ page?: number, limit?: number }} params
   */
  async getConversationMessages(conversationId, { page = 1, limit = 50 } = {}) {
    return api.get(
      `/whatsapp/conversations/${conversationId}/messages?page=${page}&limit=${limit}`,
      true
    )
  },

  /**
   * Envía un mensaje de texto al cliente (handoff asignado).
   * Solo funciona dentro de la ventana de 24 h de WhatsApp.
   * @param {number|string} conversationId
   * @param {string} message
   */
  async sendMessage(conversationId, message) {
    return api.post(`/whatsapp/conversations/${conversationId}/messages`, { message }, true)
  },

  /**
   * Cierra el handoff y reactiva el bot automático para la conversación.
   * @param {number|string} conversationId
   */
  async resolveHandoff(conversationId) {
    return api.post(`/whatsapp/conversations/${conversationId}/resolve`, {}, true)
  },

  /**
   * Disponibilidad del envío por la API (plan basic+ y toggle de plataforma) y cupo del mes.
   * Nunca exige plan: con plan free responde `api_available: false`.
   */
  async getUsage() {
    return api.get('/whatsapp/usage', true)
  },

  /**
   * Envía (o reenvía) el recordatorio de la cita desde el número de la plataforma.
   * Errores con `data.code`: QUOTA_EXCEEDED, RESEND_COOLDOWN (`retry_after_seconds`),
   * RESEND_LIMIT, OPTED_OUT, NO_PHONE, INVALID_STATUS, PLATFORM_DISABLED, NOT_CONFIGURED.
   * @param {number|string} appointmentId
   */
  async sendAppointmentReminder(appointmentId) {
    return api.post(`/whatsapp/appointments/${appointmentId}/reminder`, {}, true)
  },

  /**
   * Recordatorios (flows) y mensajes de WhatsApp de una cita.
   * @param {number|string} appointmentId
   */
  async getAppointmentHistory(appointmentId) {
    return api.get(`/whatsapp/appointments/${appointmentId}/messages`, true)
  }
}
